<template>
    <section id="home-slide-features" class="p-lg-5 m-0 text-start container-fluid">
        <div class="py-5">
            <h1>{{ gettext("Nos fonctionnalités") }}</h1>
        </div>

        <div id="carouselFeatures" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators mt-5">
                <button type="button" data-bs-target="#carouselFeatures" data-bs-slide-to="0" class="active"
                    aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#carouselFeatures" data-bs-slide-to="1"
                    aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#carouselFeatures" data-bs-slide-to="2"
                    aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#carouselFeatures" data-bs-slide-to="3"
                    aria-label="Slide 4"></button>
            </div>
            <div class="carousel-inner features py-3">

                <div class="carousel-item active">
                    <div class="feature main row items-center text-center">
                        <p class="col-lg-6 shrink-2 fw-bold">Trois services automatisés reliés entre eux pour forger
                            l'écosystème permettant de développer votre actionnariat.</p>
                        <div class="col-lg-6 hidden lg:block"><img class="image-fluid" src="/static/img/FIRST.png" />
                        </div>
                    </div>
                </div>
                <div class="carousel-item ">
                    <div class="feature left flex justify-center items-center m-2">
                        <div class="feature-pad hidden lg:block me-n5">
                            <img class="" src="/static/img/PAD_TKAPI.png" />
                        </div>
                        <div class="frame">
                            <div class="frame-content p-5">
                                <h3 class="shrink-3 p-2 m-0">{{ gettext("TABLE DE CAPITALISATION DEMATERIALISEE") }}</h3>
                                <small class="shrink-4">{{ gettext("Historique / Mouvements / Modélisation") }}</small>
                                <ul class="py-3 flex items-baseline flex-col">
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Tenez votre registre d'actionnaires à jour de manière automatisée.
                                    </li>
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Importez votre table de capitalisation et observez son évolution.
                                    </li>
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Créez de nouveaux mouvements.
                                    </li>
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Simulez des évolutions du capital et modélisez tous vos instruments
                                        financiers, puis partagez-les.
                                    </li>
                                </ul>
                                <button class="btn btn-outline-primary shrink-3 fw-bold" onclick="openCrisp()">En savoir
                                    plus sur T-Kapi</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="feature right flex justify-center items-center m-2">
                        <div class="frame green">
                            <div class="frame-content p-5">
                                <h3 class="shrink-3 p-2 m-0">{{ gettext("DATAROOM SECURISEE") }}</h3>
                                <small class="shrink-4">{{ gettext("Création / Stockage / Partage") }}</small>
                                <ul class="py-3 flex items-baseline flex-col ">
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Générez vos documents seul ou en équipe, ou utilisez nos templates.
                                    </li>
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Organisez tous vos documents dans votre DataRoom personnelle.
                                    </li>
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Partagez vos documents et gérez les droits d'accès à tout moment.
                                    </li>
                                </ul>
                                <button class="btn btn-outline-primary shrink-3 fw-bold" onclick="openCrisp()">Demandez une
                                    démo</button>
                            </div>
                        </div>
                        <div class="feature-pad hidden lg:block ms-n5">
                            <img class="" src="/static/img/PAD_DATAROOM.png" />
                        </div>
                    </div>
                </div>
                <div class="carousel-item">
                    <div class="feature left flex justify-center items-center m-2">
                        <div class="feature-pad hidden lg:block me-n5">
                            <img class="" src="/static/img/PAD_EVENT.jpg" />
                        </div>
                        <div class="frame">
                            <div class="frame-content p-5">
                                <h3 class="shrink-3 p-2 m-0">{{ gettext("ESPACES EVENEMENTS") }}</h3>
                                <small class="shrink-4">{{ gettext("Gestion / Convocation / Participation") }}</small>
                                <ul class="flex items-baseline flex-col">
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Gérez vos assemblées générales et boards en un seul espace.
                                    </li>
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Gestionnaire : convoquez, suivez les votes en direct et générez votre PV
                                        automatiquement.
                                    </li>
                                    <li>
                                        <div class="puce">
                                            <div>
                                                <fa icon="check" />
                                            </div>
                                        </div>Actionnaires : participez, répondez, votez, en avance ou en direct.
                                    </li>
                                </ul>
                                <button class="btn btn-outline-primary shrink-3 fw-bold"
                                    @click="redirectContactMeeting">En savoir plus</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselFeatures" data-bs-slide="prev">
                <fa icon="chevron-left" aria-hidden="true" />
                <span class="visually-hidden">{{ gettext("Previous") }}</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselFeatures" data-bs-slide="next">
                <fa icon="chevron-right" aria-hidden="true" />
                <span class="visually-hidden">{{ gettext("Next") }}</span>
            </button>
        </div>

    </section>
</template>


<script>
import slide from "@/pages/homepage/slide/slide.js";

export default {
    mixins: [slide],
    methods: {
        redirectContactMeeting() {
            window.location.href = "/contact/meetings";
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";

#home-slide-features {
    background-color: white;
    ;
    color: $primary;

    .carousel-indicators {
        line-height: 20px;
        height: 20px;

        button {
            border: 0;
            background-color: $primary;
            margin: 5px;
            width: 50px;
            height: 10px;
            line-height: 20px;
        }

        button.active {
            background-color: $secondary;
        }
    }

    .carousel-control-prev,
    .carousel-control-next {
        font-size: 2.5em;
        color: $secondary;
        border: 0;
        background-color: transparent;
    }

    // Disabled until full refacto
    // .carousel-control-prev:hover,
    // .carousel-control-next:hover {
    //     background-color: $primary;
    //     opacity: 0.5;
    // }

    .features {
        .feature.main {
            >div>img {
                max-height: 500px;
            }
        }

        .feature {
            min-height: 500px;

            >.feature-pad {
                z-index: 1;
                padding: 0;
                border: 15px solid black;
                border-radius: 15px;
                overflow: hidden;

                >img {
                    max-height: 200px;
                }
            }

            >.frame {
                display: flex;
                /* contexte sur le parent */

                .frame-content {
                    border: 10px solid $primary;

                    >h3 {
                        background-color: $secondary;
                    }

                    >ul {
                        padding: 0;

                        >li {
                            list-style: none;

                            >.puce {
                                display: inline-block;
                                vertical-align: middle;
                                width: 20px;
                                height: 20px;
                                line-height: 20px;

                                border: 2px solid $secondary;
                                border-radius: 50%;
                                font-size: 1.5em;
                                margin-right: 10px;

                                >* {
                                    margin-top: -6px;
                                    margin-left: -3px;
                                }
                            }
                        }
                    }
                }
            }

            >.frame.green>.frame-content {
                border-color: $secondary;
            }
        }

        .feature.right {
            >.feature-pad {
                >img {
                    max-height: 300px;
                }
            }

        }
    }
}
</style>
